document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-site-header]');

if (header) {
  const setHeaderState = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  };

  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });
}

document.querySelectorAll('.mobile-menu__panel a').forEach((link) => {
  link.addEventListener('click', () => {
    const details = link.closest('details');
    if (details) details.removeAttribute('open');
  });
});
